import axios from "axios";
// import store from "./store";
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
// currently using cookie for authentication.
// post requests are protected with csrf token via X-XSRF-TOKEN header
// If token is required, use:
// axios.defaults.headers.common["Authorization"] = "Bearer: " + state.u.api_token;

export default {
  install(Vue, options) {
    Vue.prototype.$sisApi = (method, route, params = {}) => {
      // console.log(store.state.u);
      // params["api_token"] = state.u.api_token;
      if (!route.startsWith("/")) {
        route = "/api/" + route;
      }

      if (
        method == "post" ||
        method == "put" ||
        method == "patch"
      ) {
        return axios[method](route, params);
      }

      if (method == "post-file") {
        let formData = new FormData();
        formData.append(params.name, params.file);
        return axios["post"](route, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      let keys = Object.keys(params);
      let q = keys
        .map(function(k) {
          return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
        })
        .join("&");
      if (keys.length > 0) {
        route += "?" + q;
      }

      if (
        method == "get" ||
        method == "delete"
      ) {
        return axios[method](route);
      }

      if (method == "get-file") {
        return axios["get"](route, { responseType: "blob" });
      }
    };
  },
};
